import type { Language } from './language';

export type DCStatus = 'online' | 'degraded' | 'offline';

export function pickLang(language: Language, en: string, fa: string): string {
  return language === 'fa' ? fa : en;
}

/** Presentational card for DataCenterGrid (not wired to live ISP data). */
export interface DataCenterCard {
  id: string;
  name: string;
  locationEn: string;
  locationFa: string;
  status: DCStatus;
  uptimePct: number;
  lastIncidentEn: string;
  lastIncidentFa: string;
}
